import React from 'react';
import type { QuickChartData } from '@trinity/chat';
import { ProgressBarScaleWrapper, ProgressBarScaleContent } from './ProgressBarPreviewScaling';
import { SemiCircleScaleWrapper, SemiCircleScaleContent } from './SemiCircleProgressPreviewScaling';

/**
 * Renders chart previews with appropriate scaling/wrapping based on chart type.
 *
 * Currently handles:
 * - progress-bar-widget: Wraps in scaling components for consistent preview sizing
 * - semi-circle-progress-widget: Wraps in semi-circle scaling components
 * - Other charts: Renders directly without modification
 */
export const ChartPreviewRenderer: React.FC<{ chartData: QuickChartData; children: React.ReactNode }> = ({
  chartData,
  children,
}) => {
  if (chartData.type === 'progress-bar-widget') {
    return (
      <ProgressBarScaleWrapper>
        <ProgressBarScaleContent>{children}</ProgressBarScaleContent>
      </ProgressBarScaleWrapper>
    );
  }

  if (chartData.type === 'semi-circle-progress-widget') {
    return (
      <SemiCircleScaleWrapper>
        <SemiCircleScaleContent>{children}</SemiCircleScaleContent>
      </SemiCircleScaleWrapper>
    );
  }

  return <>{children}</>;
};
